import React, { useState, useEffect } from "react";

import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';

import SidePanel from "@component/SidePanel"
import { usePostsQuery } from "@query/postQuery";

import { useTranslation } from "react-i18next";

import { formatDateTimeWithoutSeconds } from "@utils/timeUtil";
import AddIcon from '@mui/icons-material/Add';
import PostForm from "@component/PostForm";
import PostCreateForm from "@component/PostCreateForm";


export default function PostsPage() {
  const [posts, setPosts] = useState(null);

  const { t } = useTranslation(["main", "posts"]);

  const [postDetailOpen, setPostDetailOpen] = useState(false);
  const [selectedItemUuid, setSelectedItemUuid] = useState(null);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10
  });

  const postsQuery = usePostsQuery(paginationModel.page);

  function handleOnPostDetailClick() {
    setPostDetailOpen(false)
    postsQuery.refetch()
  }

  useEffect(() => {
    if (postsQuery.data?.data) {
      setPosts(postsQuery.data.data);
    }
  }, [postsQuery.data]);

  const handleRowClick = (uuid) => {
    setSelectedItemUuid(uuid);
    setPostDetailOpen(true);
  };

  const handleNewPostClick = () => {
    console.log(null);
    setSelectedItemUuid(null);
    setPostDetailOpen(true);
  };

  const handleOnCreateClose = () => {
    setSelectedItemUuid(null);
    setPostDetailOpen(false);
  };

  const handleSave = () => {
    postsQuery.refetch();
  };

  const handleDelete = () => {
    setSelectedItemUuid(null);
    setPostDetailOpen(false);
    postsQuery.refetch();
  };

  const handleOnCreateSave = () => {
    handleSave();
    setSelectedItemUuid(null);
    setPostDetailOpen(false);
  };

  const columns = [
    {
      field: "heading",
      headerName: t('posts:heading'),
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 250,
      // cellClassName: 'column-heading'
    },
    {
      field: "creator",
      headerName: t('posts:author'),
      sortable: false,
      filterable: false,
      width: 200,
      valueFormatter: (params) => {
        if (params) {
          return params.first_name + " " + params.last_name;
        }
        return "";
      },
    },
    {
      field: "created_on",
      headerName: t('posts:published'),
      sortable: false,
      filterable: false,
      width: 200,
      valueFormatter: (params) => {

        if (params) {
          return formatDateTimeWithoutSeconds(params);
        }
        return '';
      },
    },
    {
      field: "updated_on",
      headerName: t('posts:lastModified'),
      sortable: false,
      filterable: false,
      width: 200,
      valueFormatter: (params) => {

        if (params) {
          return formatDateTimeWithoutSeconds(params);
        }
        return '';
      },
    },
  ];

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "95%", md: "95%" },
        display: "flex",
        flexDirection: "column",
        gap: 3,
        mx: "auto",
        pb: 4,
        pt: 4
      }}
    >

      <SidePanel
        open={postDetailOpen}
        onClose={handleOnPostDetailClick}
        title={t('posts:post')}
      >
        {
          selectedItemUuid ?
            <PostForm uuid={selectedItemUuid} onSave={handleSave} onDelete={handleDelete} /> :
            <PostCreateForm onSave={handleOnCreateSave} onCancel={handleOnCreateClose} />
        }

      </SidePanel>

      <Box sx={{
        flex: 1,
        height: 400,
        minWidth: 0
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h2" gutterBottom>
              {t('posts:posts')}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {t('posts:pageSubtitle')}
            </Typography>
          </Box>
          <Button
            startIcon={<AddIcon />}
            variant="contained"
            onClick={() => handleNewPostClick()}
            sx={{ mb: 2 }}
          >
            {t('posts:createPost')}
          </Button>
        </Box>
        <DataGrid
          sx={{
            '& .MuiDataGrid-row': {
              cursor: 'pointer'
            },
            '& .column-heading': {
              fontWeight: 'bold'
            }
          }}
          paginationMode="server"
          rowCount={posts?.pagination?.total_items || 0}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          rows={posts?.items.map(post => ({ ...post, id: post.uuid }))}
          loading={postsQuery.isFetching}
          columns={columns}
          onRowClick={(params) => handleRowClick(params.id)}
          disableRowSelectionOnClick
          hideFooterSelectedRowCount={true}
          pageSizeOptions={[]}
        />
      </Box>
    </Box>
  );
}
